// @flow
import { Logout } from 'grommet-icons/es6';
import * as React from 'react';
import {
    Box, Button,
} from 'grommet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ApiClient } from 'speed-js-core';
import { connectAPI, withRouter } from 'speed-js-react';
import { removeUser, setPermissions } from 'speed-js-react/src/redux/auth/actions';
import { getUserFullName, getUser } from 'speed-js-react/src/redux/auth/selector';
import { FormattedMessage } from 'react-intl';
import connectWS from 'speed-js-react/src/websocket/connectWS';
import ProfileMenu from 'esm-web-pro/containers/layout/ProfileMenu';
import WebSocketClient from 'speed-js-core/src/websocket/WebSocketClient';
import {
    LANDING_TAB_LC_KEY,
    LANDING_TAB_WS_COMMAND,
} from 'esm-web-pro/containers/pages/landing/LandingTabController';
import { getIsLandingTab, setLandingTab } from 'esm-web-pro/redux/landingTab';

const locales = {
    login: (
        <FormattedMessage
            id="account-menu.login"
            defaultMessage="Login"
            description="Login button"
        />
    ),
    logOut: (
        <FormattedMessage
            id="account-menu.log-out"
            defaultMessage="Log out"
            description="Log out button"
        />
    ),
};

const mapStateToProps = (state) => ({
    fullName: getUserFullName(state),
    user: getUser(state),
    isLandingTab: getIsLandingTab(state),
});

const mapDispatchToProps = (dispatch: function) => ({
    dispatchRemoveUser: () => dispatch(removeUser()),
    dispatchSetPermissions: (permissions: Object) => dispatch(setPermissions(permissions)),
    dispatchSetLandingTab: (isLandingTab: boolean | null) => dispatch(setLandingTab(isLandingTab)),
});

type Props = {
    fullName: ?string,
    logout: (data: Object) => Promise<Object>,
    history: { push: (location: string) => void },
    // eslint-disable-next-line
    redirectTo: string,
    ws: WebSocketClient,
}


@withRouter
@connect(mapStateToProps, mapDispatchToProps)
@connectWS
@connectAPI((apiClient: ApiClient, props: Props) => ({
    logout: {
        send: () => apiClient.deauthorize(),
        success: () => {
            props.ws.reconnect();
            const {
                history, dispatchRemoveUser, redirectTo, dispatchSetPermissions,
                dispatchSetLandingTab,
            } = props;
            dispatchSetPermissions({});
            history.push(redirectTo);
            dispatchRemoveUser();
            dispatchSetLandingTab(null);
        },
    },
}))
class AccountMenu extends React.Component<Props> {
    static defaultProps: Object;

    menuItems: Array<Object>;

    constructor(props: Props) {
        super(props);

        this.menuItems = [];

        if (this.menuItems) {
            this.menuItems.push({
                key: 'logOut',
                label: locales.logOut,
                icon: <Logout />,
                onClick: this.handleLogoutClick,
            });
        }
    }

    handleLogoutClick = (event: SyntheticMouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        const {
            logout, ws,
        } = this.props;

        ws.send(LANDING_TAB_WS_COMMAND, {
            action: 'logout',
        });
        ws.send(LANDING_TAB_WS_COMMAND, {
            action: 'unregistered_landing_tab',
        });
        window.localStorage.removeItem(LANDING_TAB_LC_KEY);
        logout();
    };

    renderProfileMenu = () => (
        <ProfileMenu
            actions={this.menuItems}
        />
    );

    renderLoginButtons = () => (
        <Box direction="row" align="end" gap="small" pad={{ vertical: 'small' }}>
            <Link to="/account/login"><Button label={locales.login} as="span" /></Link>
        </Box>
    );

    render() {
        const { fullName } = this.props;

        if (fullName) {
            return this.renderProfileMenu();
        }

        return this.renderLoginButtons();
    }
}

AccountMenu.defaultProps = {
    redirectTo: '/',
};

export default AccountMenu;
